import React from "react";
import PropTypes from "prop-types";

export default function SmallLoadingSpinner({ className }) {
  return (
    <div className="spinner-container loading-overlay w-full z-50">
      <div
        className={`${className} loading-spinner animate-spin border-50 border-t-black`}
      ></div>
    </div>
  );
}
SmallLoadingSpinner.propTypes = {
  className: PropTypes.string.isRequired,
};
